<div
  class="card-container h-100 w-100 rounded-5 border d-flex flex-column align-items-center py-3 gap-4"
  [ngClass]="classes"
>
  <div
    class="d-flex flex-column align-items-center w-75 gap-2 title-card-container"
  >
    <img [src]="iconUrl" alt="icone" />
    <p
      class="text-white m-0 fs-4 fs-card-title fw-bold text-center font-museo-moderno lh-1"
    >
      {{ title }}
    </p>
  </div>

  <div
    class="d-flex flex-column align-items-center py-4 px-4 gap-3 bg-white rounded-5 white-container"
    [ngClass]="whiteContainerBorder"
  >
    <img
      class="perval-logo"
      src="assets/perval-icons/perval_card_title.svg"
      alt="Perval"
    />
    <div class="m-0 text-center fs-card-body fw-medium">
      <ng-content select="[firstDescription]"></ng-content>
    </div>
  </div>
  <div
    class="d-flex flex-column align-items-center justify-content-start fs-card-body"
  >
    <p class="fw-bold m-0 text-center">DVF</p>
    <p
      class="m-0 text-center px-4 w-100 fw-medium"
      [class.smallWidth]="smallWidth"
      [class.mediumWidth]="mediumWidth"
    >
      {{ secondDescription }}
    </p>
  </div>
</div>
